import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid, Typography } from '@mui/material';
import Heading from '../../Components/LockerMenu/component/Heading';
import Paragraph from '../../Components/LockerMenu/component/Paragraph';
import solidproof from '../../../assets/solidproof.svg';
import contractaudit from '../../../assets/contract2.png';
import KYC from '../../../assets/tier.png';

const Wrapper = styled(Box)`
  padding: 80px 0px;
  position: relative;

  @media (max-width: 768px) {
    padding: 40px 0px;
  }
`;

const BgBox = styled(Box)`
  width: 100%;
  max-width: 1200px;
  height: 60vh;
  position: relative;
  border-radius: 20px;
  background-color: #f5f5f5;
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
    text-align: center;
    justify-content: center;
  }
`;

const FrontBox = styled(Box)`
  position: absolute;
  right: 0;
  top: -30px;
  width: 50%;
  height: 110%;
  background-color: #f1f7ff;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    top: 0;
    padding: 20px;
  }
`;

const ContentBox = styled(Box)`
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  z-index: 3;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    padding: 20px;
  }
`;

const ImageWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  margin-top: 15px;

  @media (max-width: 350px) {
    gap: 5px; 
    flex-direction: column;
  }
`;

const AICMAudits = () => {
  return (
    <Wrapper>
      <Container maxWidth="lg">
        <Grid container justifyContent={'center'}>
          <Grid item xs={12}>
            <BgBox>
              <ContentBox>
                <Heading sx={{ marginBottom: { xs: '50px', sm: '105px' } }}>AICM Audits</Heading>
                <Paragraph>
                  AICM has successfully completed the KYC & Audit with SolidProof.io. This ensures that AICM operates transparently, adheres to regulatory requirements, and fosters a safe environment for the users.
                </Paragraph>
              </ContentBox>

              <FrontBox>
                <Box sx={{ textAlign: 'center', color: 'white', cursor: 'pointer' }}>
                  <img src={solidproof} alt="SolidProof" draggable='false' style={{ width:'100%',maxWidth:'300px',height:'auto' }} />
                  <ImageWrapper>
                    {/* <a href='https://app.solidproof.io/projects/aicm' target='_blank'>
                      <img src={contractaudit} alt="Audit" draggable='false' style={{width:'100%',maxWidth:'160px',height:'auto'}} />
                    </a> */}
                    <a href='https://app.solidproof.io/projects/aicm' target='_blank'>
                      <img src={KYC} alt="KYC" draggable='false' style={{width:'100%',maxWidth:'150px',height:'auto'}}/>
                    </a>
                  </ImageWrapper>
                </Box>
              </FrontBox>
            </BgBox>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default AICMAudits;
